import * as React from 'react';
import { Tabs, Col, Row } from 'antd';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
const TabPane = Tabs.TabPane;
import * as uuid from 'uuid';

import { ContractGeneralController } from './parts/contract-general.controller';
import { ContractsServiceController } from './parts/contract-service.controller';
import { ContractsAgeBandController } from './parts/contract-ageband.controller';
import { ContractCostController } from './parts/contract-cost.controller';
import { ContractsDateBandController } from './parts/contract-dateband.controller';
import { ContractsMarketController } from './parts/contract-market.controller';
import { AllotmentAvailabilityController } from 'src/app/products/allotment/form/parts/allotment-availability.controller';
import { ContractSimulatorView } from 'src/app/products/contractSimulator/contract-simulator.view';
import { SupplierListDataService } from 'src/app/products/suppliers/list/supplier-list.data';
import { ExtendedSchemaView } from 'src/core/ui/extended-schema.view';
import { ErrataListController } from 'src/app/general/erratas/list/errata-list.controller';

interface ContractFormViewProps extends ComponentViewProps<ContractItem> {
	mode: ControlMode;
	onModeChanged: (mode: ControlMode) => void;
	contextService: any;
	formatService: any;
	supplierType: number;
	product: ProductItem | TourItineraryItem;
	currencies: CurrencySummary[];
	generatePrices: (priceCurrency: CurrencySummary) => void;
	selectedMarket: number;
	onMarketChange?: (market: number) => void;
	defaultLanguaje: string;
	breadcrumb?: any[];
	isNew: boolean;
	isDirty: boolean;
	isValidGeneralInfo: boolean;
	onValidateGeneralInfo: (contract: ContractItem) => void;
	schema: JsonSchema;
	identityService: any;
}
interface State {
	activeKey:string
}
@observer
export class ContractFormView extends React.Component<ContractFormViewProps, State> {
	@observable
	protected supplier: SupplierSummary;
	constructor(props: Readonly<ContractFormViewProps>) {
		super(props);
		this.state = {
			activeKey: "Common information"
		};
	}
	componentDidMount() {
		this.props.setBusy(true);
		const promises = [];
		if (!this.props.isNew) {
			promises.push(this.loadSupplier());
		}

		Promise.all(promises)
			.catch(() => { })
			.then(() => {
				this.props.setBusy(false);
			});
	}

	componentWillReceiveProps(nextProps: Readonly<ContractFormViewProps>, nextContext: any) {
	}

	private async loadSupplier(): Promise<void> {
		const supplierListDataService = SupplierListDataService.make(this.props.contextService);
		supplierListDataService.addFilter('id', 'eq', this.props.model.supplierId);
		supplierListDataService.addSorting('id', 'asc', true);
		supplierListDataService.pageSize = 1;
		await supplierListDataService.load(query => query);
		this.supplier = supplierListDataService.item;
	}
	
	
	private get hasExtendedProperties(): boolean {
		return this.props.schema.allOf != null && this.props.schema.allOf.length > 0 && Object.getOwnPropertyNames(this.props.schema.allOf[0].properties).length > 0;
	}

	private updatePriceTable = () => this.forceUpdate();

	private updateAgeBands = (items: AgeBandItem[], oldType?: string, newType?: string) => {
		this.updateStructure("cost", items, oldType, newType);
		this.updateStructure("price", items, oldType, newType);
	}

	private updateStructure(type: "cost" | "price", items: AgeBandItem[], oldType?: string, newType?: string) {
		const obj: CostItem = this.props.model.dynamicProperties[type];
		const structure = obj.structure;
		const elements = structure.customOccupancyConfigs;
		for (const item of items) {
			for (const ele of elements) {
				if (oldType != null && newType != null) {
					const aux = ele[oldType];
					ele[oldType] = undefined;
					ele[newType] = aux;
				} else {
					ele[item.label?item.label.toLocaleLowerCase():item.type.toString().toLowerCase()] = undefined;
				}
			}
		}
	}
	onChange = (activeKey) => {
		this.setState({ activeKey });
	}
	render() {
		if (this.props.model == null) {
			return null;
		}

		const { isValidGeneralInfo } = this.props;
		const simulatorDisabled =  this.props.isDirty;
		const ageband: AgeBandItem[] = this.props.model.dynamicProperties['ageBands'];
		const pivotArray: any[] = [];
		pivotArray.push(
			<TabPane tab="Common information" key="Common information">
				<Row gutter={16}>
					<Col xs={24}>
						<ContractGeneralController
							mode={this.props.mode}
							defaultLanguaje={this.props.defaultLanguaje}
							onModeChanged={this.props.onModeChanged}
							model={this.props.model}
							setBusy={this.props.setBusy}
							product={this.props.product}
							supplierType={this.props.supplierType}
							supplierChange={(newVal: SupplierSummary) => {
								this.supplier = newVal;
							}}
							contextService={this.props.contextService}
							onValidateGeneralInfo={this.props.onValidateGeneralInfo}
						/>
					</Col>
					<Col xs={24} xl={12}>
						<ContractsServiceController
							product={this.props.product}
							mode={this.props.mode}
							onModeChanged={this.props.onModeChanged}
							model={this.props.model}
							setBusy={this.props.setBusy}
							contextService={this.props.contextService}
						/>
					</Col>
					<Col xs={24} xl={12}>
						<ContractsMarketController
							contextService={this.props.contextService}
							mode={this.props.mode}
							onModeChanged={this.props.onModeChanged}
							model={this.props.model}
							setBusy={this.props.setBusy}
						/>
					</Col>
				</Row>
			</TabPane>,
			<TabPane disabled={!isValidGeneralInfo} tab='Date & Age bands' key="Date & Age bands">
				<Row gutter={16}>
					<Col xs={24} xl={14}>
						<ContractsDateBandController
							mode={this.props.mode}
							onModeChanged={this.props.onModeChanged}
							model={this.props.model}
							setBusy={this.props.setBusy}
							contextService={this.props.contextService}
							formatService={this.props.formatService}
							product={this.props.product}
							updatePriceTable={this.updatePriceTable}
						/>
					</Col>
					<Col xs={24} xl={10}>
						<ContractsAgeBandController
							mode={this.props.mode}
							model={ageband}
							setBusy={this.props.setBusy}
							updateAgeBands={this.updateAgeBands}
						/>
					</Col>
				</Row>
			</TabPane>,
			<TabPane disabled={!isValidGeneralInfo} tab='Cost' key='Cost'>
				<ContractCostController
					key="cost"
					productType={(this.props.product as any).productType}
					mode={this.props.mode}
					onModeChanged={this.props.onModeChanged}
					model={this.props.model}
					type="cost"
					setBusy={this.props.setBusy}
					currencies={this.props.currencies}
					supplier={this.supplier}
				/>
			</TabPane>,
			<TabPane disabled={!isValidGeneralInfo} tab="Price" key='Price'>
				<ContractCostController
					key="price"
					productType={(this.props.product as any).productType}
					mode={this.props.mode}
					onModeChanged={this.props.onModeChanged}
					model={this.props.model}
					type="price"
					setBusy={this.props.setBusy}
					currencies={this.props.currencies}
					supplier={this.supplier}
					generatePrices={this.props.generatePrices}
					selectedMarket={this.props.selectedMarket}
					onMarketChange={this.props.onMarketChange}
				/>
			</TabPane>,
			<TabPane tab="Errata" key="Errata">
				<Row>
					<Col xs={24}>
						<ErrataListController
							model={this.props.model.dynamicProperties['erratas']}
							mode={this.props.mode}
							identityService={this.props.identityService}
							setBusy={this.props.setBusy}
						/>
					</Col>
				</Row>
			</TabPane>,
			<TabPane tab='Contract simulator' key="simulator" disabled={simulatorDisabled}>
				<ContractSimulatorView
					mode='display'
					disabled={simulatorDisabled}
					defaultLanguage={this.props.defaultLanguaje}
					formatService={this.props.formatService}
					setBusy={this.props.setBusy}
					model={this.props.model}
					defaultMarket={this.props.selectedMarket}
					product={this.props.product}
					breadcrumb={this.props.breadcrumb}

				/>
			</TabPane>
		);
		if (this.props.model.allotment || this.props.model.allotmentId) {
			pivotArray.push(<TabPane disabled={!isValidGeneralInfo} tab="Availability Allotment" key="Availability Allotment" >
				{<AllotmentAvailabilityController
					contextService={this.props.contextService}
					defaultLanguaje={this.props.defaultLanguaje}
					suppliers={[]}
					mode={this.props.mode}
					idSuplier={this.props.model.supplierId}
					onModeChanged={this.props.onModeChanged}
					model={this.props.model.allotmentId}
					setBusy={this.props.setBusy}
				/>}
			</TabPane >)
		}
		if (this.hasExtendedProperties) {
			pivotArray.splice(1, 0, (
				<TabPane tab={<span>Other Properties</span>} key="Other Properties">
					<ExtendedSchemaView
						mode={this.props.mode}
						columns={2}
						model={this.props.model.dynamicProperties}
						schema={this.props.schema}
						setBusy={this.props.setBusy}
						title="Other Information"
					/>
				</TabPane>
			));
		}

		return (
			<Row>
				<Col xs={24}>
					<div className='card p-3'>
						<Tabs activeKey={this.state.activeKey} onChange={this.onChange}>
							{pivotArray}
						</Tabs>
					</div>
				</Col>
			</Row>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/products/contract/form/contract-form.view.tsx